import {
  InstanceObservabilityEvent,
  InstanceObservabilityStatus,
} from 'modules/environments/interfaces';

const SEVERITY_RANK: Record<InstanceObservabilityStatus, number> = {
  critical: 0,
  warning: 1,
  healthy: 2,
};

export const getEventSeverityRank = (
  status: InstanceObservabilityStatus | null
): number => (status === null ? 3 : SEVERITY_RANK[status] ?? 3);

export const sortEventsBySeverity = (
  events: InstanceObservabilityEvent[]
): InstanceObservabilityEvent[] =>
  [...events].sort(
    (a, b) => getEventSeverityRank(a.status) - getEventSeverityRank(b.status)
  );

export type EventStatusVariant =
  | 'healthy'
  | 'warning'
  | 'critical'
  | 'notReported';

const VARIANT_BY_STATUS: Record<
  InstanceObservabilityStatus,
  EventStatusVariant
> = {
  healthy: 'healthy',
  warning: 'warning',
  critical: 'critical',
};

export const getEventStatusVariant = (
  status: InstanceObservabilityStatus | null
): EventStatusVariant =>
  status === null ? 'notReported' : VARIANT_BY_STATUS[status] ?? 'notReported';

const LABEL_KEY_BY_VARIANT: Record<EventStatusVariant, string> = {
  healthy: 'INSTANCE_OBSERVABILITY.STATUS_HEALTHY',
  warning: 'INSTANCE_OBSERVABILITY.STATUS_WARNING',
  critical: 'INSTANCE_OBSERVABILITY.STATUS_CRITICAL',
  notReported: 'INSTANCE_OBSERVABILITY.STATUS_NOT_REPORTED',
};

export const getEventStatusLabelKey = (
  status: InstanceObservabilityStatus | null
): string => LABEL_KEY_BY_VARIANT[getEventStatusVariant(status)];

export const getEventDescriptionKey = (descriptionCode: string): string =>
  `INSTANCE_OBSERVABILITY.EVENT_DESCRIPTIONS.${descriptionCode}`;
